import { Autocomplete, TextField } from '@mui/material';
import React from 'react';
import { FieldHookConfig, useField } from 'formik';

/**
 * Objet qui permet d'avoir les props de formik plus les attributs que le veut custom
 */
type MyInputProps = FieldHookConfig<string> & {
    id: string;
    label: string;
    name: string;
    otherElement?: any;
    options: any[];
    handleInputChange?: any;
    sx?: any;
    attributValueName?: string;
};

/**
 * Composant AutoComplete
 * @param props MyInputProps
 * @constructor
 */
export default function AutocompleteForm(props: MyInputProps) {
    //UseField
    const [field, meta, helpers] = useField(props);
    //permet de gerer la valeur pour le submit
    const getValueFromOptions = (value: any) => props.options.find((option: any) => option === value) ?? null;

    //Création du champ input
    return (
        //Mise en pla ce de l'autocomplete
        <Autocomplete
            {...field}
            sx={props.sx}
            data-testid={'autocomplete-' + props.id}
            disablePortal
            id={props.id}
            autoHighlight
            options={props.options}
            onChange={(event, value) => {
                helpers.setValue(value != null ? value : '');
            }}
            filterOptions={options => options}
            onInputChange={props.handleInputChange}
            value={getValueFromOptions(field.value)}
            renderInput={params => (
                <>
                    <TextField
                        {...params}
                        name={props.name}
                        label={props.label}
                        error={Boolean(meta.error)}
                        helperText={Boolean(meta.error) && meta.error}
                    />
                    {props.otherElement}
                </>
            )}
        ></Autocomplete>
    );
}
